import React from "react";
import PropTypes from "prop-types";

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";

import contentPageStyle from "assets/jss/material-dashboard-pro-react/views/contentPageStyle.jsx";


class HomePage extends React.Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify="center">
          </GridContainer>
        </div>
      </div>  
    );
  }
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
  return {
    page: props.location.pathname.replace("/pages/","").replace("-","_"),
    translate: getTranslate(state.localize),
  }
}

export default compose(
  withStyles(contentPageStyle),
  connect(mapStateToProps, null)
)(HomePage);


// WEBPACK FOOTER //
// ./src/views/Pages/HomePage.jsx